"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
const TARGET_IDS = [24, 25, 27];
const KNOWLEDGE_CATS = [{
  id: TARGET_IDS,
  label: "全部文章",
  enLabel: "All About Flooring"
}, {
  id: 24,
  label: "選地板這件事",
  enLabel: "Flooring Essentials"
}, {
  id: 27,
  label: "日常保養照顧",
  enLabel: "Living With Your Floor"
}, {
  id: 25,
  label: "施工前先看看",
  enLabel: "Before Getting Started"
}];
export default function Categories() {
  const {
    query,
    setQuery
  } = usePosts();
  const currentCat = query?.cat;
  return <div className="grid grid-cols-2 md:flex md:flex-wrap items-center justify-center gap-4 md:gap-6 w-full max-w-5xl mx-auto">
      {KNOWLEDGE_CATS.map(item => {
      const isAllPostsButton = Array.isArray(item.id);
      const isActive = isAllPostsButton ? Array.isArray(currentCat) && currentCat.length === item.id.length || !currentCat : currentCat === item.id;
      return <button key={item.label} onClick={() => setQuery({
        ...query,
        cat: item.id,
        paged: 1
      })} className={cn(
      //  核心修改 2：比例全面精緻縮小
      // - 手機版高度 h-14 (56px)，電腦版高度 md:h-16 (64px)
      // - 手機版內距 px-4 改小，避免中英文字被兩側截斷
      // - w-full：在手機 grid 底下會自動填滿 50% 寬度格子；md:w-auto 還原桌機自適應寬度
      "group relative flex flex-col items-center justify-center px-4 md:px-10 h-15 md:h-17 rounded-full border transition-all duration-300 ease-out cursor-pointer w-full md:w-auto md:min-w-[170px] select-none text-center", isActive ? "bg-[#604f45] border-[#604f45] text-white shadow-md" : "bg-transparent border-[#604f45] text-[#604f45] hover:bg-[#604f45] hover:border-[#604f45] hover:text-white")}>
            {/* 中文標題：
                 配合高度縮小，常態向下沉的微調距離由 translate-y-3.5 縮小到 translate-y-2.5 
             */}
            <span className={cn("font-hk-regular text-xs md:text-sm font-medium tracking-widest transition-transform duration-300 ease-out whitespace-nowrap", isActive ? "translate-y-0" : "translate-y-2.5 md:translate-y-3 group-hover:translate-y-0")}>
              {item.label}
            </span>

            {/* 細分界線：常態縮短為 w-8 (配合按鈕縮小) */}
            <div className={cn("w-8 transition-all duration-300 ease-out overflow-hidden", isActive ? "h-0 my-0 opacity-0 scale-50 pointer-events-none" : "h-[1px] my-1 opacity-0 scale-50 bg-white/40 group-hover:opacity-100 group-hover:scale-100")} />

            {/* 英文標題：字體微調為 text-[9px] md:text-[10px] 確保手機小螢幕不折行 */}
            <span className={cn("font-sans text-[9px] md:text-[10px] tracking-wide font-light transition-all duration-300 ease-out whitespace-nowrap", isActive ? "opacity-0 translate-y-1 pointer-events-none absolute" : "text-[#604f45]/0 opacity-0 translate-y-1 group-hover:text-white/80 group-hover:opacity-100 group-hover:translate-y-0")}>
              {item.enLabel}
            </span>
          </button>;
    })}
    </div>;
}